import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme, { isOrderDetailsOpen } = {}) => ({
  sectionTitle: {
    fontWeight: '700',
    fontSize: '16px',
    lineHeight: '24px',
    marginTop: '5px',
  },
  collapseIcon: { marginTop: '2px' },
  orderInfoHeader: {
    marginBottom: isOrderDetailsOpen ? theme.spacing(2) : 0,
  },
}));
